import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from '../../organization/hooks/useSelectedOrganization';
import { CreditPackDto, GET_CREDIT_PACKS_QUERY_KEY } from './useListCreditPacks';

export type UpdateCreditPackInput = {
  name?: string;
  priceInCents?: number;
  credits?: number;
  isActive?: boolean;
  sortOrder?: number;
};

export const useUpdateCreditPack = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  const { selectedOrganization } = useSelectedOrganization();

  return useMutation({
    mutationFn: ({ id, ...input }: UpdateCreditPackInput & { id: string }) =>
      client.fetchApi<CreditPackDto, UpdateCreditPackInput>({
        endpoint: `wallet/admin/credit-packs/${id}`,
        method: 'PUT',
        body: input,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_CREDIT_PACKS_QUERY_KEY(selectedOrganization?.id || ''),
      });
    },
  });
};
